// 9fbef606107a605d69c0edbcd8029e5d
export const DELAY_TO_OPEN = 300;

export const DELAY_TO_CLOSE = 300;

export const CLEARANCE_ID = '505518';

export default { DELAY_TO_OPEN, CLEARANCE_ID };
